// extracted by mini-css-extract-plugin
export default {"carousal_item":"Liabilities_carousal_item__vC2nI","liabilityCard":"Liabilities_liabilityCard__kO9EU"};